module.exports = __webpack_public_path__ + "assets/img/18_924_big.346080e2.jpg";